var map = {
	"./layouts/document.pdf.less": 1167,
	"./templates/core/documents/pdfContainer/pdfContainer.pdf.less": 1168,
	"./templates/core/documents/sign/sign.pdf.less": 1169,
	"./templates/core/documents/table/table.pdf.less": 1170
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1166;